import { Component } from "react"

class Sex extends Component{
    constructor(props){
        super(props)
        this.name = "性別"
    }
    validate(callbackDialog){
        if(String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(!(this.props === "0" || this.props === "1" || this.props === "2")){
            callbackDialog("エラー",this.name + "は「男」または「女」を選択してください。")
            return false
        }
        return true
    }
}

export default Sex;